export enum LessonFormFields {
    NAME = 'name',
    IMAGE = 'image',
    TAG_A = 'tagA',
    TAG_B = 'tagB',
    MAX_POINTS = 'maxPoints',
    DESCRIPTION = 'description',
}